import React, { useState } from 'react';
import './../css/about.css';

const ArtistCard = (props:any) => {
    const [showMore, setShowMore] = useState(false);

    // Destructure props to extract artistDes and artistImg
    const { artistDes, artistImg, artistName } = props;



    return (
        <div className="artist_container">
            <img src={artistImg} alt="artist pic" />
            <h2>{artistName}</h2>
            {/* Use text variable for conditional rendering */}
            <p className="text_nofont">{showMore ? artistDes : artistDes.substring(0, 300) + '...'}</p>

            <button className="btn" onClick={() => setShowMore(!showMore)}>{showMore ? 'See Less' : 'See More'}</button>
        </div>
    );
}

export default ArtistCard;
